/**
 * SWELLのFAQブロックをアコーディオン化する（排他制御・アニメーション付き）
 */
export function initFaqAccordion() {
	const faqItems = document.querySelectorAll(".page-faq .swell-block-faq__item");
	if (faqItems.length === 0) return;

	faqItems.forEach((item) => {
		const q = item.querySelector(".faq_q");
		const a = item.querySelector(".faq_a");
		if (!q || !a) return;

		// 【初期状態】最初はすべて閉じておく（インラインで高さを0にする）
		a.style.height = "0px";
		a.style.overflow = "hidden";
		a.style.transition = "height 0.3s cubic-bezier(0.4, 0, 0.2, 1)";

		q.addEventListener("click", () => {
			const isOpen = item.classList.contains("is-active");

			// 他に開いているFAQがあれば、すべて閉じる（排他制御）
			faqItems.forEach((otherItem) => {
				if (otherItem !== item && otherItem.classList.contains("is-active")) {
					otherItem.classList.remove("is-active");
					const otherA = otherItem.querySelector(".faq_a");
					if (otherA) otherA.style.height = "0px";
				}
			});

			// クリックされたFAQの開閉切り替え
			if (isOpen) {
				// 閉じる時
				item.classList.remove("is-active");
				a.style.height = "0px";
			} else {
				// 開く時（scrollHeightで中身の正確な高さを取得してぬるっと広げる）
				item.classList.add("is-active");
				a.style.height = `${a.scrollHeight}px`;
			}
		});
	});
}
